module.exports = __webpack_public_path__ + "img/calendar.891b965d.svg";